// extracted by mini-css-extract-plugin
export default {"resident":"resident-e29f"};